import { RESOURCES } from './resources';

export default RESOURCES;
